import React from 'react';
import Toast from './Toast';

/**
 * ToastContainer Component
 * Renders all active toasts
 * Receives toasts and removeToast from context
 */
const ToastContainer = ({ toasts, removeToast }) => {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-[9999] space-y-3 max-w-sm w-full pointer-events-none"
      role="region"
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            variant={toast.variant}
            message={toast.message}
            title={toast.title}
            duration={toast.duration}
            onDismiss={() => removeToast(toast.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
